import {
	SET_POSTS_DATA,
	ADD_POST,
	DELETE_POST,
	ADD_TEXT_AREA,
	DELETE_TEXT_AREA,
	CLEAN_POSTS_DATA
} from '../../constants/postsData';

const setPostsData = (data, key) => {
	return {
		type: SET_POSTS_DATA,
		key,
		payload: data
	};
};

const addPost = (data) => {
	return {
		type: ADD_POST,
		payload: data
	};
};

const deletePost = (key) => {
	return {
		type: DELETE_POST,
		key
	};
};

const addTextArea = (key) => {
	return {
		type: ADD_TEXT_AREA,
		key
	};
};

const deleteTextArea = (key) => {
	return {
		type: DELETE_TEXT_AREA,
		key
	};
};

const cleanPostsData = () => {
	return {
		type: CLEAN_POSTS_DATA
	};
};

export { setPostsData, addPost, deletePost, addTextArea, deleteTextArea, cleanPostsData };
